import React from "react";
import FormRender from "@/components/Form/Renderer/RenderForm";
import { editRole } from "@/services/role.services";
import { setPageEvent } from "@/store/features/dashboardSlice";
import { useAppDispatch } from "@/store/store";
import { EditRoleConfig } from "@/utils/constant/roles";
import { toastMessage } from "@/utils/helper/myToast";

const EditRole: React.FC<{ role: any; onClose: any }> = ({ role, onClose }) => {
  const dispatch = useAppDispatch();

  const handleFormSubmit = async (formData: any) => {
    if (role?.roleName === formData.roleName) return toastMessage("No changes detected", true);
    const res: any = await editRole({ roleName: formData.roleName, roleId: role.roleId });
    if (res?.status === 200) {
      const { message, isError } = res.data;
      onClose({ disabledWarning: true });
      dispatch(setPageEvent({ keys: ["role-list"], type: "refresh" }));
      return toastMessage(message, isError);
    } else {
      console.log("Error", res);
      const { message, isError } = res?.response?.data || {};
      if (message) {
        return toastMessage(message, isError);
      }
      if (res.message) {
        return toastMessage(res.message, true);
      }
    }
  };
  return (
    <FormRender
      useFormConfig={{ mode: "onSubmit", reValidateMode: "onChange", criteriaMode: "all" }}
      handleFormSubmit={handleFormSubmit}
      handleCancel={onClose}
      formConfig={EditRoleConfig}
      defaultValues={role}
      className="p-4 overflow-y-auto h-[calc(100%-30px)]"
      formClassName="h-full justify-between"
      btnContainerClass=" sticky bottom-0 bg-white py-5"
    />
  );
};

export default EditRole;
